module.exports = __webpack_public_path__ + "static/griffin-c814787c7a3db665c810d9ec3324274f.jpg";